enum Vote {
  Cancel = "Cancel",
  Draw = "Draw",
  Pause = "Pause",
}

export default Vote;
